import I18n from 'I18n';
export const composeValidators = (...validators) => value => validators.reduce((error, validator) => error || validator(value), undefined);
export const isValidLength = max => value => (value === null || value === void 0 ? void 0 : value.length) > max ? I18n.text('profilePage.Forms.validators.isValidLength', {
  max
}) : undefined;
export const isValidCharacters = value => {
  if (!value) return undefined;
  const regex = /^[A-Za-z0-9/_-]+$/;
  if (regex.test(value)) {
    return undefined;
  }
  const invalidChars = (value.match(/[^A-Za-z0-9/_-]/g) || []).filter((char, index, self) => self.indexOf(char) === index).map(char => char === ' ' ? 'spaces' : char).join(', ');
  const message = I18n.text('profilePage.Forms.validators.invalidCharacters');
  return `${message}: ${invalidChars}`;
};